import Vue from 'vue'
import Vuex from 'vuex'

// 引入模块
import user from './modules/user'
import app from './modules/app'
import task from './modules/task'

// 注册 Vuex 插件
Vue.use(Vuex)

// 创建 Store 实例
const store = new Vuex.Store({
  modules: {
    user,
    app,
    task
  },
  // 根级别的 state
  state: {

  },
  // 根级别的 mutations
  mutations: {

  },
  // 根级别的 actions
  actions: {

  },
  // 根级别的 getters
  getters: {

  }
})

export default store
